/**
 * DLT Buy Box v27.1 · desconto percentual premium na PDP
 * Asset externo, inicialização resiliente e otimizações de performance.
 */
(function () {
  'use strict';

  if (window.DLTBuyBox && typeof window.DLTBuyBox.boot === 'function') {
    window.DLTBuyBox.boot(document);
    return;
  }

  var ROOT_SELECTOR = '[data-dlt-buybox-root]';
  var instances = new Map();
    var bootFrame = 0;
  var pendingScopes = [];
  var cartRefreshTimer = 0;
  var quickBenefitsMedia = window.matchMedia ? window.matchMedia('(max-width: 1199px)') : null;

  var cartCache = {
    data: null,
    at: 0,
    url: '',
    promise: null
  };

  var moneyFormatter = null;

  try {
    moneyFormatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  } catch (error) {
    moneyFormatter = null;
  }

  function moneyBr(cents) {
    var normalized = Number(cents) || 0;

    if (moneyFormatter) {
      return moneyFormatter.format(normalized / 100);
    }

    return 'R$ ' + (normalized / 100).toFixed(2).replace('.', ',');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function escapeSelectorValue(value) {
    var normalized = String(value == null ? '' : value);

    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(normalized);
    }

    return normalized.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function variantKey(options) {
    return JSON.stringify(Array.isArray(options) ? options : []);
  }

  function parseJsonScript(root, selector) {
    var element = root.querySelector(selector);

    if (!element) return [];

    try {
      var parsed = JSON.parse(element.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.warn('[DLT Buy Box] Não foi possível interpretar as variantes.', error);
      return [];
    }
  }

  function normalizeCampaignDate(value) {
    if (!value) return null;

    var raw = String(value).trim();
    if (!raw) return null;

    if (raw.indexOf('T') < 0 && raw.indexOf(' ') > -1) {
      raw = raw.replace(' ', 'T');
    }

    if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(raw)) {
      raw += '-03:00';
    }

    var date = new Date(raw);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  function formatCountdown(milliseconds, label) {
    var totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var prefix = label || 'Termina em';

    if (days > 0) {
      return (
        prefix +
        ' ' +
        days +
        'd ' +
        String(hours).padStart(2, '0') +
        'h ' +
        String(minutes).padStart(2, '0') +
        'm'
      );
    }

    return (
      prefix +
      ' ' +
      String(hours).padStart(2, '0') +
      'h ' +
      String(minutes).padStart(2, '0') +
      'm ' +
      String(seconds).padStart(2, '0') +
      's'
    );
  }

  function applyCampaignTokens(template, values) {
    var output = String(template || '');
    var tokens = values || {};

    Object.keys(tokens).forEach(function (key) {
      output = output.split('[' + key + ']').join(tokens[key]);
    });

    return output;
  }

  function getCampaignCartBasis(cartState) {
    if (!cartState) return 0;

    if (typeof cartState.total_price === 'number') {
      return Math.max(0, cartState.total_price);
    }

    if (typeof cartState.items_subtotal_price === 'number') {
      return Math.max(0, cartState.items_subtotal_price);
    }

    if (typeof cartState.original_total_price === 'number') {
      return Math.max(0, cartState.original_total_price);
    }

    if (Array.isArray(cartState.items)) {
      return cartState.items.reduce(function (total, item) {
        var lineValue = 0;

        if (typeof item.final_line_price === 'number') {
          lineValue = item.final_line_price;
        } else if (typeof item.line_price === 'number') {
          lineValue = item.line_price;
        } else if (typeof item.original_line_price === 'number') {
          lineValue = item.original_line_price;
        }

        return total + Math.max(0, lineValue || 0);
      }, 0);
    }

    return 0;
  }

  function setCartCache(cartState, url) {
    if (!cartState) return;

    cartCache.data = cartState;
    cartCache.at = Date.now();
    cartCache.url = url || cartCache.url;
  }

  function fetchCart(root, force) {
    var url =
      (root && root.getAttribute('data-cart-json-url')) ||
      (window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart.js'
        : 'cart.js');

    var now = Date.now();

    if (
      !force &&
      cartCache.data &&
      cartCache.url === url &&
      now - cartCache.at < 500
    ) {
      return Promise.resolve(cartCache.data);
    }

    if (cartCache.promise && cartCache.url === url) {
      return cartCache.promise;
    }

    cartCache.url = url;

    cartCache.promise = fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('cart_fetch_failed');
        }

        return response.json();
      })
      .then(function (cartState) {
        setCartCache(cartState, url);
        return cartState;
      })
      .finally(function () {
        cartCache.promise = null;
      });

    return cartCache.promise;
  }

  function copyText(value) {
    var text = String(value || '');

    if (!text) return Promise.reject(new Error('empty_copy_value'));

    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      textarea.style.pointerEvents = 'none';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        var copied = document.execCommand('copy');
        textarea.remove();

        if (copied) {
          resolve();
        } else {
          reject(new Error('copy_command_failed'));
        }
      } catch (error) {
        textarea.remove();
        reject(error);
      }
    });
  }

  function dispatchDocumentEvent(name, detail) {
    document.dispatchEvent(
      new CustomEvent(name, {
        bubbles: true,
        detail: detail || {}
      })
    );
  }

  function applyCartStateToInstances(cartState) {
    instances.forEach(function (instance) {
      if (instance && instance.root && instance.root.isConnected) {
        instance.applyCartState(cartState);
      }
    });
  }

  function refreshAllCartStates(force) {
    var firstInstance = null;

    instances.forEach(function (instance) {
      if (!firstInstance && instance.root && instance.root.isConnected) {
        firstInstance = instance;
      }
    });

    if (!firstInstance) return Promise.resolve(null);

    return fetchCart(firstInstance.root, !!force)
      .then(function (cartState) {
        applyCartStateToInstances(cartState);
        return cartState;
      })
      .catch(function () {
        return null;
      });
  }

  function BuyBox(root) {
    this.root = root;
    this.uid = root.getAttribute('data-dlt-buybox-id') || '';
    this.variants = parseJsonScript(root, '[data-dlt-buybox-variants]');
    this.variantMap = new Map();
    this.selectedOptions = [];
    this.currentVariant = null;
    this.isSubmitting = false;
    this.countdownTimer = 0;
    this.nativeFormCache = null;
    this.copyResetTimers = new WeakMap();
    this.controller = new AbortController();
    this.pendingTimers = [];

    this.pixPercent =
      parseInt(root.getAttribute('data-pix-percent'), 10) || 5;
    this.showPixDiscount =
      root.getAttribute('data-show-pix-discount') === 'true';
    this.redirectToCheckout =
      root.getAttribute('data-redirect-checkout') === 'true';
    this.defaultButtonText =
      root.getAttribute('data-default-button-text') || 'Adicionar';

    this.refs = {};
    this.campaign = null;

    this.variants.forEach(
      function (variant) {
        this.variantMap.set(variantKey(variant.options), variant);
      }.bind(this)
    );
  }


  BuyBox.prototype.listen = function (
    target,
    eventName,
    handler,
    options
  ) {
    if (!target || !target.addEventListener) return;

    var settings = options || {};
    settings.signal = this.controller.signal;
    target.addEventListener(eventName, handler, settings);
  };

  BuyBox.prototype.schedule = function (callback, delay) {
    var self = this;
    var timer = window.setTimeout(function () {
      self.pendingTimers = self.pendingTimers.filter(
        function (current) {
          return current !== timer;
        }
      );
      callback();
    }, delay);

    this.pendingTimers.push(timer);
    return timer;
  };

  BuyBox.prototype.byId = function (prefix) {
    return document.getElementById(prefix + '-' + this.uid);
  };

  BuyBox.prototype.queryAll = function (selector) {
    return Array.prototype.slice.call(this.root.querySelectorAll(selector));
  };

  BuyBox.prototype.cacheReferences = function () {
    this.refs = {
      compare: this.byId('db-cmp'),
      saleBadge: this.byId('db-sale-badge'),
      salePercent: this.byId('db-sale-percent'),
      saving: this.byId('db-sav'),
      savingLabel: this.byId('db-sav-label'),
      savingValue: this.byId('db-sav-value'),
      savingTip: this.byId('db-sav-tip'),
      discountRow: this.byId('db-discount-row'),
      priceGrid: this.byId('db-price-grid'),
      pixValue: this.byId('db-pv'),
      installmentValue: this.byId('db-iv'),
      variantInput: this.byId('db-vid'),
      stockRegion: this.byId('db-sr'),
      currentPrice: this.byId('db-cur'),
      cashValue: this.byId('db-cash-value'),
      quantityInput: this.byId('db-qi'),
      formQuantity: this.byId('db-fq'),
      minusButton: this.byId('db-minus'),
      plusButton: this.byId('db-plus'),
      form: this.byId('db-form'),
      button: this.byId('db-btn'),
      quickButton: this.byId('db-qc-btn'),
      pixBadge: this.byId('db-pix-badge-wrap'),
      gift: this.byId('db-gift-campaign'),
      compactGift: this.root.querySelector('[data-gift-campaign-compact]')
    };
  };

  BuyBox.prototype.init = function () {
    if (this.root.dataset.dltBuyboxInitialized === 'true') return this;

    this.cacheReferences();
    this.setupCampaign();
    this.bindCouponButtons();
    this.bindSelectors();
    this.bindQuantity();
    this.bindPixBadge();
    this.bindPurchaseActions();

    this.root.dataset.dltBuyboxInitialized = 'true';

    if (this.campaign) {
      this.refreshCart(false);
      this.syncCountdownTimer();
    }

    return this;
  };

  BuyBox.prototype.destroy = function () {
    this.stopCountdown();
    this.controller.abort();
    this.pendingTimers.forEach(function (timer) {
      window.clearTimeout(timer);
    });
    this.pendingTimers = [];
    this.root.dataset.dltBuyboxInitialized = 'false';
    instances.delete(this.uid);
  };

  BuyBox.prototype.getNativeForm = function () {
    if (this.nativeFormCache && this.nativeFormCache.isConnected) {
      return this.nativeFormCache;
    }

    var nativeFormId = this.root.getAttribute('data-native-form-id');
    this.nativeFormCache = nativeFormId
      ? document.getElementById(nativeFormId)
      : null;

    return this.nativeFormCache;
  };

  BuyBox.prototype.findVariant = function (options) {
    return this.variantMap.get(variantKey(options)) || null;
  };

  BuyBox.prototype.findVariantById = function (variantId) {
    var targetId = String(variantId || '');

    return (
      this.variants.find(function (variant) {
        return String(variant.id) === targetId;
      }) || null
    );
  };

  BuyBox.prototype.getActiveVariant = function () {
    if (this.currentVariant) return this.currentVariant;

    var selected = this.findVariant(this.selectedOptions);
    if (selected) return selected;

    return (
      this.findVariantById(
        this.root.getAttribute('data-current-variant-id')
      ) ||
      this.variants[0] ||
      null
    );
  };

  BuyBox.prototype.clampQuantity = function (value) {
    var parsed = parseInt(value, 10);

    if (Number.isNaN(parsed)) parsed = 1;

    return Math.max(1, Math.min(99, parsed));
  };

  BuyBox.prototype.syncNativeQuantity = function () {
    var nativeForm = this.getNativeForm();
    if (!nativeForm) return;

    var nativeQuantity = nativeForm.querySelector('[name="quantity"]');
    var quantity = this.refs.formQuantity
      ? this.refs.formQuantity.value
      : 1;

    if (nativeQuantity) {
      nativeQuantity.value = quantity || 1;
    }
  };

  BuyBox.prototype.updateStickyPrice = function (variant) {
    var nativeForm = this.getNativeForm();
    if (!nativeForm || !variant) return;

    var selector =
      '[data-sticky-price-stack][data-form-id="' +
      escapeSelectorValue(nativeForm.id) +
      '"]';

    document.querySelectorAll(selector).forEach(function (stack) {
      var compare = stack.querySelector('[data-sticky-compare-at]');
      var sale = stack.querySelector('[data-sticky-sale]');

      if (sale) sale.textContent = moneyBr(variant.price);

      if (!compare) return;

      var stickyCompareAt = Number(variant.compare_at_price) || 0;
      var stickyPrice = Number(variant.price) || 0;
      var stickyDiscountPercent =
        stickyCompareAt > stickyPrice && stickyCompareAt > 0
          ? Math.round(
              ((stickyCompareAt - stickyPrice) * 100) /
                stickyCompareAt
            )
          : 0;

      if (stickyDiscountPercent > 0) {
        compare.textContent = moneyBr(stickyCompareAt);
        compare.hidden = false;
      } else {
        compare.textContent = '';
        compare.hidden = true;
      }
    });
  };

  BuyBox.prototype.syncNativeVariant = function (variant) {
    var nativeForm = this.getNativeForm();
    if (!nativeForm || !variant) return;

    var nativeId = nativeForm.querySelector('[name="id"]');

    if (nativeId) {
      nativeId.disabled = false;
      nativeId.value = variant.id;
      nativeId.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }

    this.syncNativeQuantity();
    this.updateStickyPrice(variant);

    nativeForm.dispatchEvent(
      new CustomEvent('variant:change', {
        bubbles: true,
        detail: {
          product: {
            id: Number(this.root.getAttribute('data-product-id')) || null,
            handle: this.root.getAttribute('data-product-handle') || '',
            title: this.root.getAttribute('data-product-title') || ''
          },
          variant: variant
        }
      })
    );

    if (
      window.history &&
      window.history.replaceState &&
      window.location &&
      window.location.search.indexOf('variant=') > -1
    ) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(
          {
            path: url.toString()
          },
          '',
          url.toString()
        );
      } catch (error) {
        // URL antiga ou ambiente sem suporte completo.
      }
    }
  };

  BuyBox.prototype.setupCampaign = function () {
    var gift = this.refs.gift;

    if (!gift) {
      this.campaign = null;
      return;
    }

    var compact = this.refs.compactGift;

    this.campaign = {
      gift: gift,
      compact: compact,
      threshold: parseInt(gift.getAttribute('data-threshold'), 10) || 0,
      requiresMinimum:
        gift.getAttribute('data-requires-minimum') !== 'false',
      endDate: normalizeCampaignDate(gift.getAttribute('data-end')),
      countdownEnabled:
        gift.getAttribute('data-countdown-enabled') !== 'false',
      countdownLabel:
        gift.getAttribute('data-countdown-label') || 'Termina em',
      hideAfterEnd:
        gift.getAttribute('data-hide-after-end') === 'true',
      couponCode: gift.getAttribute('data-coupon-code') || '',
      beforeMessage: gift.getAttribute('data-before-message') || '',
      reachedMessage: gift.getAttribute('data-reached-message') || '',
      currentReachedMessage:
        gift.getAttribute('data-current-reached-message') || '',
      projectedReachedMessage:
        gift.getAttribute('data-projected-reached-message') || '',
      endedMessage: gift.getAttribute('data-ended-message') || '',
      countdown: gift.querySelector('[data-gift-countdown]'),
      message: gift.querySelector('[data-gift-message]'),
      progress: gift.querySelector('[data-gift-progress]'),
      state: gift.querySelector('[data-gift-state]'),
      math: gift.querySelector('[data-gift-math]'),
      compactState: compact
        ? compact.querySelector('[data-gift-compact-state]')
        : null,
      compactCountdown: compact
        ? compact.querySelector('[data-gift-compact-countdown]')
        : null,
      cartTotal:
        parseInt(gift.getAttribute('data-cart-total'), 10) || 0
    };

    if (this.campaign.threshold <= 0) {
      this.campaign.requiresMinimum = false;
    }
  };

  BuyBox.prototype.stopCountdown = function () {
    if (!this.countdownTimer) return;

    window.clearInterval(this.countdownTimer);
    this.countdownTimer = 0;
  };

  BuyBox.prototype.syncCountdownTimer = function () {
    this.stopCountdown();

    if (!this.campaign) return;

    this.updateGiftCampaign(this.getActiveVariant());

    var campaign = this.campaign;

    if (
      !campaign.countdownEnabled ||
      !campaign.endDate ||
      campaign.endDate.getTime() <= Date.now() ||
      document.hidden
    ) {
      return;
    }

    this.countdownTimer = window.setInterval(
      function () {
        if (document.hidden || !this.root.isConnected) return;

        this.updateGiftCampaign(this.getActiveVariant());

        if (
          this.campaign &&
          this.campaign.endDate &&
          this.campaign.endDate.getTime() <= Date.now()
        ) {
          this.stopCountdown();
        }
      }.bind(this),
      1000
    );
  };

  BuyBox.prototype.applyCartState = function (cartState) {
    if (!this.campaign || !cartState) return;

    this.campaign.cartTotal = getCampaignCartBasis(cartState);
    this.campaign.gift.setAttribute(
      'data-cart-total',
      String(this.campaign.cartTotal)
    );

    this.updateGiftCampaign(this.getActiveVariant());
  };

  BuyBox.prototype.refreshCart = function (force) {
    if (!this.campaign) return Promise.resolve(null);

    return fetchCart(this.root, !!force)
      .then(
        function (cartState) {
          this.applyCartState(cartState);
          return cartState;
        }.bind(this)
      )
      .catch(function () {
        return null;
      });
  };

  BuyBox.prototype.updateGiftCampaign = function (variant) {
    var campaign = this.campaign;
    if (!campaign) return;

    var gift = campaign.gift;
    var compact = campaign.compact;
    var now = Date.now();

    if (
      campaign.endDate &&
      now >= campaign.endDate.getTime()
    ) {
      gift.classList.add('is-ended');
      gift.classList.remove(
        'is-reached',
        'is-current-reached',
        'is-projected-reached',
        'is-below-threshold'
      );

      if (compact) {
        compact.classList.add('is-ended');
        compact.classList.remove(
          'is-reached',
          'is-current-reached',
          'is-projected-reached',
          'is-below-threshold'
        );
      }

      this.stopCountdown();

      if (campaign.hideAfterEnd) {
        gift.hidden = true;
        if (compact) compact.hidden = true;
        return;
      }

      gift.hidden = false;
      if (compact) compact.hidden = false;

      if (campaign.countdown) {
        campaign.countdown.textContent = 'Encerrada';
      }

      if (campaign.compactCountdown) {
        campaign.compactCountdown.textContent = 'Encerrada';
      }

      if (campaign.compactState) {
        campaign.compactState.textContent = 'Encerrada';
      }

      if (campaign.state) {
        campaign.state.hidden = false;
        campaign.state.textContent = 'Encerrada';
      }

      if (campaign.message) {
        campaign.message.textContent = applyCampaignTokens(
          campaign.endedMessage || 'Campanha encerrada.',
          {
            cupom: campaign.couponCode,
            valor: moneyBr(campaign.threshold),
            faltam: moneyBr(0),
            carrinho: moneyBr(campaign.cartTotal),
            produto: moneyBr(0),
            total: moneyBr(campaign.cartTotal)
          }
        );
      }

      if (campaign.math) {
        campaign.math.hidden = true;
        campaign.math.textContent = '';
      }

      if (campaign.progress) {
        campaign.progress.style.width = '100%';
      }

      return;
    }

    gift.hidden = false;
    gift.classList.remove('is-ended');

    if (compact) {
      compact.hidden = false;
      compact.classList.remove('is-ended');
    }

    if (campaign.countdown) {
      if (campaign.countdownEnabled && campaign.endDate) {
        campaign.countdown.hidden = false;
        campaign.countdown.textContent = formatCountdown(
          campaign.endDate.getTime() - now,
          campaign.countdownLabel
        );
      } else {
        campaign.countdown.hidden = true;
      }
    }

    if (campaign.compactCountdown) {
      if (campaign.countdownEnabled && campaign.endDate) {
        campaign.compactCountdown.hidden = false;
        campaign.compactCountdown.textContent = formatCountdown(
          campaign.endDate.getTime() - now,
          campaign.countdownLabel
        );
      } else {
        campaign.compactCountdown.hidden = true;
      }
    }

    var quantity = this.refs.formQuantity
      ? this.clampQuantity(this.refs.formQuantity.value)
      : 1;

    var variantPrice =
      variant && typeof variant.price === 'number'
        ? variant.price
        : 0;

    var cartBasisTotal = Math.max(
      0,
      Number(campaign.cartTotal) || 0
    );

    var productAddTotal = Math.max(
      0,
      variantPrice * quantity
    );

    var projectedTotal = cartBasisTotal + productAddTotal;
    var requiresMinimum =
      campaign.requiresMinimum && campaign.threshold > 0;

    var currentReached = requiresMinimum
      ? cartBasisTotal >= campaign.threshold
      : true;

    var projectedReached = requiresMinimum
      ? projectedTotal >= campaign.threshold
      : true;

    var campaignReached =
      currentReached || projectedReached;

    var progressBasis = requiresMinimum
      ? campaignReached
        ? campaign.threshold
        : projectedTotal
      : 100;

    var percentage = requiresMinimum
      ? Math.min(
          100,
          Math.max(
            0,
            Math.round(
              (progressBasis / campaign.threshold) * 100
            )
          )
        )
      : 100;

    var missing =
      requiresMinimum && !campaignReached
        ? Math.max(0, campaign.threshold - projectedTotal)
        : 0;

    var tokenValues = {
      cupom: campaign.couponCode,
      valor: moneyBr(campaign.threshold),
      faltam: moneyBr(missing),
      carrinho: moneyBr(cartBasisTotal),
      produto: moneyBr(productAddTotal),
      total: moneyBr(projectedTotal)
    };

    gift.classList.toggle('is-reached', campaignReached);
    gift.classList.toggle(
      'is-current-reached',
      currentReached
    );
    gift.classList.toggle(
      'is-projected-reached',
      !currentReached && projectedReached
    );
    gift.classList.toggle(
      'is-below-threshold',
      requiresMinimum && !campaignReached
    );

    if (compact) {
      compact.classList.toggle(
        'is-reached',
        campaignReached
      );
      compact.classList.toggle(
        'is-current-reached',
        currentReached
      );
      compact.classList.toggle(
        'is-projected-reached',
        !currentReached && projectedReached
      );
      compact.classList.toggle(
        'is-below-threshold',
        requiresMinimum && !campaignReached
      );
    }

    gift.setAttribute(
      'data-cart-current',
      String(cartBasisTotal)
    );
    gift.setAttribute(
      'data-product-add-total',
      String(productAddTotal)
    );
    gift.setAttribute(
      'data-projected-total',
      String(projectedTotal)
    );
    gift.setAttribute(
      'data-missing-total',
      String(missing)
    );

    if (campaign.progress) {
      campaign.progress.style.width = percentage + '%';
    }

    if (campaign.state) {
      campaign.state.hidden = false;

      if (currentReached) {
        campaign.state.textContent = 'Já liberado';
      } else if (projectedReached) {
        campaign.state.textContent = 'Libera ao adicionar';
      } else if (requiresMinimum) {
        campaign.state.textContent =
          'Faltam ' + moneyBr(missing);
      } else {
        campaign.state.textContent = 'Ativa';
      }
    }

    if (campaign.compactState) {
      if (currentReached) {
        campaign.compactState.textContent = 'Já liberado';
      } else if (projectedReached) {
        campaign.compactState.textContent =
          'Libera ao adicionar';
      } else if (requiresMinimum) {
        campaign.compactState.textContent =
          'Faltam ' + moneyBr(missing);
      } else {
        campaign.compactState.textContent = 'Ver detalhes';
      }
    }

    if (campaign.math) {
      if (requiresMinimum) {
        campaign.math.hidden = false;

        if (currentReached) {
          campaign.math.textContent =
            'Seu carrinho atual já está em ' +
            moneyBr(cartBasisTotal) +
            '.';
        } else {
          campaign.math.textContent =
            'Carrinho ' +
            moneyBr(cartBasisTotal) +
            ' + este item ' +
            moneyBr(productAddTotal) +
            ' = ' +
            moneyBr(projectedTotal) +
            '.';
        }
      } else {
        campaign.math.hidden = true;
        campaign.math.textContent = '';
      }
    }

    if (campaign.message) {
      var template;

      if (currentReached) {
        template =
          campaign.currentReachedMessage ||
          campaign.reachedMessage ||
          'Campanha liberada.';
      } else if (projectedReached) {
        template =
          campaign.projectedReachedMessage ||
          campaign.reachedMessage ||
          'Campanha liberada ao adicionar este item.';
      } else {
        template =
          campaign.beforeMessage ||
          'Faltam [faltam] para liberar a campanha.';
      }

      campaign.message.textContent =
        applyCampaignTokens(template, tokenValues);
    }
  };

  BuyBox.prototype.bindCouponButtons = function () {
    var self = this;

    this.queryAll('[data-dlt-copy-coupon]').forEach(function (
      button
    ) {
      self.listen(button, 'click', function () {
        var code =
          button.getAttribute('data-dlt-copy-coupon') || '';
        var feedback = button.querySelector(
          '[data-dlt-copy-feedback]'
        );

        copyText(code)
          .then(function () {
            button.classList.add('is-copied');

            if (feedback) {
              feedback.textContent = 'copiado';
            }

            var previousTimer =
              self.copyResetTimers.get(button);

            if (previousTimer) {
              window.clearTimeout(previousTimer);
            }

            var resetTimer = self.schedule(function () {
              button.classList.remove('is-copied');

              if (feedback) {
                feedback.textContent = 'copiar';
              }
            }, 1800);

            self.copyResetTimers.set(button, resetTimer);
          })
          .catch(function () {
            if (feedback) {
              feedback.textContent = code;
            }
          });
      });
    });
  };

  BuyBox.prototype.bindSelectors = function () {
    var self = this;
    var selectors = this.queryAll('.db-os');

    selectors.forEach(function (select) {
      self.selectedOptions[
        parseInt(select.dataset.oi, 10)
      ] = select.value;

      self.listen(select, 'change', function () {
        self.selectedOptions[
          parseInt(select.dataset.oi, 10)
        ] = select.value;

        var variant = self.findVariant(
          self.selectedOptions
        );

        if (variant) {
          self.updateVariant(variant);
        }
      });
    });

    var selectedVariant = selectors.length
      ? this.findVariant(this.selectedOptions)
      : this.findVariantById(
          this.root.getAttribute('data-current-variant-id')
        ) || this.variants[0];

    if (selectedVariant) {
      this.updateVariant(selectedVariant);
    } else {
      this.markSoldOut();
    }
  };

  BuyBox.prototype.markSoldOut = function () {
    var self = this;
    var selectors = this.queryAll('.db-os');
    var currentVariant = this.findVariant(
      this.selectedOptions
    );

    selectors.forEach(function (select) {
      var optionIndex = parseInt(select.dataset.oi, 10);

      Array.prototype.forEach.call(
        select.options,
        function (option) {
          var testOptions = self.selectedOptions.slice();
          testOptions[optionIndex] = option.value;

          var variant = self.findVariant(testOptions);
          var soldOut = variant && !variant.available;

          if (
            soldOut &&
            option.text.indexOf(' ✕') < 0
          ) {
            option.text += ' ✕';
            option.style.color = '#C47A8A';
          } else if (!soldOut) {
            option.text = option.text.replace(' ✕', '');
            option.style.color = '';
          }
        }
      );

      select.classList.toggle(
        'unavail',
        !!(currentVariant && !currentVariant.available)
      );
    });
  };

  BuyBox.prototype.updateSaving = function (
    price,
    compareAtPrice,
    pixPrice
  ) {
    var refs = this.refs;
    var rawProductDiscount =
      !!compareAtPrice && compareAtPrice > price;

    var productDiscountPercent = rawProductDiscount
      ? Math.round(((compareAtPrice - price) * 100) / compareAtPrice)
      : 0;

    var hasProductDiscount =
      rawProductDiscount && productDiscountPercent > 0;

    var hasPixSaving =
      !hasProductDiscount &&
      this.showPixDiscount &&
      this.pixPercent > 0 &&
      pixPrice < price;

    if (refs.saleBadge) {
      if (productDiscountPercent > 0) {
        if (refs.salePercent) {
          refs.salePercent.textContent = productDiscountPercent + '%';
        }

        refs.saleBadge.hidden = false;
        refs.saleBadge.setAttribute(
          'aria-label',
          productDiscountPercent + '% de desconto no produto'
        );
      } else {
        if (refs.salePercent) refs.salePercent.textContent = '';
        refs.saleBadge.hidden = true;
        refs.saleBadge.removeAttribute('aria-label');
      }
    }

    var savingType = '';
    var savingCents = 0;
    var savingLabel = '';
    var savingTooltip = '';

    if (hasProductDiscount) {
      savingType = 'product';
      savingCents = compareAtPrice - price;
      savingLabel = 'Economize';
      savingTooltip =
        'Economia referente ao desconto promocional deste produto.';
    } else if (hasPixSaving) {
      savingType = 'pix';
      savingCents = price - pixPrice;
      savingLabel = 'Economize no Pix';
      savingTooltip =
        'Economia exclusiva ao escolher o pagamento via Pix.';
    }

    if (hasProductDiscount) {
      if (refs.compare) {
        refs.compare.textContent = moneyBr(compareAtPrice);
        refs.compare.style.display = '';
      }
    } else if (refs.compare) {
      refs.compare.textContent = '';
      refs.compare.style.display = 'none';
    }

    if (savingType) {
      var savingMoney = moneyBr(savingCents);

      if (refs.savingLabel) {
        if (savingType === 'pix') {
          refs.savingLabel.innerHTML = 'Economize <span class="notranslate" translate="no">no Pix</span>';
        } else {
          refs.savingLabel.textContent = savingLabel;
        }
      }

      if (refs.savingValue) {
        refs.savingValue.textContent = savingMoney;
      }

      if (refs.savingTip) {
        refs.savingTip.textContent = savingTooltip;
      }

      if (refs.saving) {
        refs.saving.dataset.savingType = savingType;
        refs.saving.classList.toggle(
          'db-sav--product',
          savingType === 'product'
        );
        refs.saving.classList.toggle(
          'db-sav--pix',
          savingType === 'pix'
        );
        refs.saving.setAttribute(
          'aria-label',
          savingLabel +
            ' ' +
            savingMoney +
            '. ' +
            savingTooltip
        );
        refs.saving.style.display = 'inline-flex';
      }

      if (refs.discountRow) {
        refs.discountRow.style.display = 'flex';
      }

      if (refs.priceGrid) {
        refs.priceGrid.classList.remove(
          'db-price-grid--without-saving'
        );
      }

      return;
    }

    if (refs.savingLabel) refs.savingLabel.textContent = '';
    if (refs.savingValue) refs.savingValue.textContent = '';
    if (refs.savingTip) refs.savingTip.textContent = '';

    if (refs.saving) {
      refs.saving.dataset.savingType = '';
      refs.saving.classList.remove(
        'db-sav--product',
        'db-sav--pix'
      );
      refs.saving.removeAttribute('aria-label');
      refs.saving.style.display = 'none';
    }

    if (refs.discountRow) {
      refs.discountRow.style.display = 'none';
    }

    if (refs.priceGrid) {
      refs.priceGrid.classList.add(
        'db-price-grid--without-saving'
      );
    }
  };

  BuyBox.prototype.updateStock = function (variant) {
    var region = this.refs.stockRegion;
    if (!region || !variant) return;

    var quantity = variant.inventory_quantity;
    var management = variant.inventory_management;

    if (!variant.available && management) {
      region.style.display = 'flex';
      region.innerHTML =
        '<div class="db-badge db-stk-c"><span class="db-dot db-dot-c"></span>Esgotado</div>';
    } else if (
      management &&
      quantity > 0 &&
      quantity <= 10
    ) {
      region.style.display = 'flex';
      region.innerHTML =
        '<div class="db-badge db-stk-c"><span class="db-dot db-dot-c"></span>Esgotando!</div>';
    } else if (
      management &&
      quantity > 10 &&
      quantity <= 50
    ) {
      region.style.display = 'flex';
      region.innerHTML =
        '<div class="db-badge db-stk-l"><span class="db-dot db-dot-l"></span>Últimas unidades</div>';
    } else {
      region.style.display = 'none';
      region.innerHTML = '';
    }
  };

  BuyBox.prototype.updateVariant = function (variant) {
    if (!variant) return;

    this.currentVariant = variant;

    var price = Number(variant.price) || 0;
    var compareAtPrice =
      Number(variant.compare_at_price) || 0;

    var pixPrice = Math.round(
      price * ((100 - this.pixPercent) / 100)
    );

    var installmentValue = Math.floor(price / 3);
    var cashAmount = Math.round(
      price * (this.pixPercent / 100)
    );

    if (this.refs.currentPrice) {
      this.refs.currentPrice.textContent = moneyBr(price);
    }

    if (this.refs.pixValue) {
      this.refs.pixValue.textContent = moneyBr(pixPrice);
    }

    if (this.refs.installmentValue) {
      this.refs.installmentValue.textContent =
        moneyBr(installmentValue);
    }

    if (this.refs.cashValue) {
      this.refs.cashValue.textContent = moneyBr(cashAmount);
    }

    if (this.refs.variantInput) {
      this.refs.variantInput.value = variant.id;
    }

    this.syncNativeVariant(variant);
    this.updateGiftCampaign(variant);
    this.updateSaving(
      price,
      compareAtPrice,
      pixPrice
    );

    this.root.setAttribute(
      'data-current-variant-id',
      String(variant.id)
    );
    this.root.setAttribute(
      'data-current-price',
      String(price)
    );
    this.root.setAttribute(
      'data-current-compare-at-price',
      String(compareAtPrice)
    );
    this.root.setAttribute(
      'data-current-available',
      variant.available ? 'true' : 'false'
    );

    dispatchDocumentEvent('dlt:pdp:variant:update', {
      source: 'dlt-buy-box',
      variantId: variant.id,
      available: !!variant.available,
      price: price,
      compareAtPrice: compareAtPrice,
      productTitle:
        this.root.getAttribute('data-product-title') || ''
    });

    if (!this.isSubmitting) {
      this.setButtonState(
        variant.available ? 'default' : 'soldout'
      );
    }

    this.updateStock(variant);
    this.markSoldOut();

    if (typeof window.__dltVimg === 'function') {
      window.__dltVimg(variant.id);
    }
  };

  BuyBox.prototype.updateQuantity = function (
    value,
    options
  ) {
    var settings = options || {};
    var raw = String(
      value == null ? '' : value
    ).replace(/[^0-9]/g, '');

    if (
      this.refs.quantityInput &&
      this.refs.quantityInput.value !== raw &&
      settings.allowEmpty
    ) {
      this.refs.quantityInput.value = raw;
    }

    if (raw === '' && settings.allowEmpty) {
      if (this.refs.formQuantity) {
        this.refs.formQuantity.value = 1;
      }

      return;
    }

    var quantity = this.clampQuantity(raw);

    if (this.refs.quantityInput) {
      this.refs.quantityInput.value = quantity;
    }

    if (this.refs.formQuantity) {
      this.refs.formQuantity.value = quantity;
    }

    this.syncNativeQuantity();
    this.updateGiftCampaign(this.getActiveVariant());
  };

  BuyBox.prototype.bindQuantity = function () {
    var self = this;

    if (this.refs.minusButton) {
      this.listen(this.refs.minusButton,
        'click',
        function () {
          var current = self.refs.quantityInput
            ? parseInt(
                self.refs.quantityInput.value,
                10
              ) || 1
            : 1;

          self.updateQuantity(current - 1);
        }
      );
    }

    if (this.refs.plusButton) {
      this.listen(this.refs.plusButton,
        'click',
        function () {
          var current = self.refs.quantityInput
            ? parseInt(
                self.refs.quantityInput.value,
                10
              ) || 1
            : 1;

          self.updateQuantity(current + 1);
        }
      );
    }

    if (!this.refs.quantityInput) return;

    this.listen(this.refs.quantityInput,
      'input',
      function () {
        self.updateQuantity(
          self.refs.quantityInput.value,
          {
            allowEmpty: true
          }
        );
      }
    );

    this.listen(this.refs.quantityInput,
      'change',
      function () {
        self.updateQuantity(
          self.refs.quantityInput.value
        );
      }
    );

    this.listen(this.refs.quantityInput,
      'blur',
      function () {
        self.updateQuantity(
          self.refs.quantityInput.value
        );
      }
    );

    this.listen(this.refs.quantityInput,
      'keydown',
      function (event) {
        if (event.key !== 'Enter') return;

        event.preventDefault();
        self.updateQuantity(
          self.refs.quantityInput.value
        );

        if (
          self.refs.button &&
          !self.refs.button.disabled &&
          !self.isSubmitting
        ) {
          self.refs.button.click();
        }
      }
    );
  };

  BuyBox.prototype.bindPixBadge = function () {
    var self = this;
    var badge = this.refs.pixBadge;

    if (!badge) return;

    this.listen(badge, 'click', function (event) {
      event.stopPropagation();
      badge.classList.toggle('active');
    });

    this.listen(this.root, 'click', function (event) {
      if (!badge.contains(event.target)) {
        badge.classList.remove('active');
      }
    });

    this.listen(badge, 'keydown', function (event) {
      if (event.key === 'Escape') {
        badge.classList.remove('active');
        badge.blur();
      }
    });

    this.listen(this.root, 'focusout', function (event) {
      if (
        !event.relatedTarget ||
        !self.root.contains(event.relatedTarget)
      ) {
        badge.classList.remove('active');
      }
    });
  };

  BuyBox.prototype.buttonMarkup = function (type) {
    if (type === 'loading') {
      return (
        '<span class="db-btn__content"><span class="db-btn__icon"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="8" stroke-opacity=".35"></circle><path d="M20 12a8 8 0 0 0-8-8"></path></svg></span><span class="db-btn__text">Adicionando...</span></span>'
      );
    }

    if (type === 'success') {
      return (
        '<span class="db-btn__content"><span class="db-btn__icon"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg></span><span class="db-btn__text">Adicionado!</span></span>'
      );
    }

    if (type === 'error') {
      return (
        '<span class="db-btn__content"><span class="db-btn__icon"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><circle cx="12" cy="16" r="1"/></svg></span><span class="db-btn__text">Tente novamente</span></span>'
      );
    }

    if (type === 'soldout') {
      return (
        '<span class="db-btn__content"><span class="db-btn__icon"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg></span><span class="db-btn__text">Produto esgotado</span></span>'
      );
    }

    return (
      '<span class="db-btn__content"><span class="db-btn__icon"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg></span><span class="db-btn__text">' +
      escapeHtml(this.defaultButtonText) +
      '</span></span>'
    );
  };

  BuyBox.prototype.setQuickState = function (state) {
    var quickButton = this.refs.quickButton;
    if (!quickButton) return;

    quickButton.classList.remove(
      'db-quick-btn-so',
      'is-loading'
    );
    quickButton.disabled = false;

    if (state === 'loading') {
      quickButton.disabled = true;
      quickButton.classList.add('is-loading');
      return;
    }

    if (state === 'soldout') {
      quickButton.disabled = true;
      quickButton.classList.add('db-quick-btn-so');
    }
  };

  BuyBox.prototype.setButtonState = function (state) {
    var button = this.refs.button;
    if (!button) return;

    button.classList.remove(
      'db-btn-loading',
      'db-btn-success',
      'db-btn-error',
      'db-btn-so'
    );

    if (state === 'loading') {
      button.disabled = true;
      button.classList.add('db-btn-loading');
      button.innerHTML = this.buttonMarkup('loading');
      this.setQuickState('loading');
      return;
    }

    if (state === 'success') {
      button.disabled = true;
      button.classList.add('db-btn-success');
      button.innerHTML = this.buttonMarkup('success');
      this.setQuickState('default');
      return;
    }

    if (state === 'error') {
      button.disabled = true;
      button.classList.add('db-btn-error');
      button.innerHTML = this.buttonMarkup('error');
      this.setQuickState('default');
      return;
    }

    if (state === 'soldout') {
      button.disabled = true;
      button.classList.add('db-btn-so');
      button.innerHTML = this.buttonMarkup('soldout');
      this.setQuickState('soldout');
      return;
    }

    button.disabled = false;
    button.innerHTML = this.buttonMarkup('default');
    this.setQuickState('default');
  };

  BuyBox.prototype.notifyCartUpdated = function () {
    var self = this;

    return fetchCart(this.root, true)
      .then(function (cartState) {
        applyCartStateToInstances(cartState);

        dispatchDocumentEvent('dlt:cart:updated', {
          cart: cartState
        });

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'dlt-buy-box:add',
              cart: cartState
            }
          })
        );

        return cartState;
      })
      .catch(function () {
        dispatchDocumentEvent('dlt:cart:updated', {
          cart: null
        });

        return null;
      });
  };

  BuyBox.prototype.addToCart = function (goToCheckout) {
    var self = this;

    if (this.isSubmitting) return false;

    var variantId = this.refs.variantInput
      ? this.refs.variantInput.value
      : '';

    var quantity = this.refs.formQuantity
      ? this.clampQuantity(
          this.refs.formQuantity.value
        )
      : 1;

    this.updateQuantity(quantity);

    if (!variantId) return false;

    this.isSubmitting = true;

    dispatchDocumentEvent('dlt:pdp:purchase:start', {
      source: 'dlt-buy-box',
      productId: Number(this.root.getAttribute('data-product-id')) || null,
      variantId: variantId,
      quantity: quantity,
      checkout: !!goToCheckout
    });

    if (goToCheckout) {
      if (this.refs.quickButton) {
        this.refs.quickButton.disabled = true;
      }

      if (this.refs.button) {
        this.refs.button.disabled = true;
      }

      this.setQuickState('loading');
    } else {
      this.setButtonState('loading');
    }

    var addUrl =
      this.root.getAttribute('data-cart-add-url') ||
      ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';

    /*
      DLT Mobile Cart R2 V70 — Uma unica mutacao no carrinho.
      A Standard Storefront Action pode estar presente, mas responder SFAPI 404
      em previews e sessoes mobile. A mera presenca de updateCart nao prova
      que o endpoint funciona. A buybox usa o Ajax Cart oficial, com URL
      locale-aware do Liquid, inclusive quando Shopify.actions esta disponivel.

      Nunca repetir POST /cart/add.js automaticamente em erro ou timeout:
      uma resposta perdida nao prova que a gravacao falhou. Isso evita
      quantidades duplicadas, tags repetidas e dois eventos por clique.
    */
    var addPromise = fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    }).then(function (response) {
      if (!response.ok) {
        var addError = new Error('add_failed');
        addError.status = response.status;
        throw addError;
      }
      return response.json();
    });

    addPromise
      .then(function () {
        dispatchDocumentEvent('dlt:pdp:purchase:success', {
          source: 'dlt-buy-box',
          productId: Number(self.root.getAttribute('data-product-id')) || null,
          variantId: variantId,
          quantity: quantity,
          checkout: !!goToCheckout
        });

        dispatchDocumentEvent('product:added', {
          source: 'dlt-buy-box',
          variantId: variantId,
          quantity: quantity
        });

        dispatchDocumentEvent('cart:refresh');
        window.dispatchEvent(
          new CustomEvent('cart-update')
        );

        self.notifyCartUpdated();

        if (
          goToCheckout ||
          self.redirectToCheckout
        ) {
          window.location.href =
            self.root.getAttribute('data-checkout-url') ||
            (((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'checkout');

          return;
        }

        self.setButtonState('success');

        self.schedule(function () {
          self.isSubmitting = false;
          self.updateVariant(
            self.findVariant(self.selectedOptions) ||
              self.findVariantById(variantId) ||
              self.variants[0]
          );
        }, 1400);
      })
      .catch(function () {
        dispatchDocumentEvent('dlt:pdp:purchase:error', {
          source: 'dlt-buy-box',
          productId: Number(self.root.getAttribute('data-product-id')) || null,
          variantId: variantId,
          quantity: quantity,
          checkout: !!goToCheckout
        });

        if (goToCheckout) {
          self.setQuickState('default');

          if (self.refs.button) {
            self.refs.button.disabled = false;
          }
        } else {
          self.setButtonState('error');
        }

        self.schedule(function () {
          self.isSubmitting = false;
          self.updateVariant(
            self.findVariant(self.selectedOptions) ||
              self.findVariantById(variantId) ||
              self.variants[0]
          );
        }, 1600);
      });

    return true;
  };

  BuyBox.prototype.bindPurchaseActions = function () {
    var self = this;

    if (this.refs.form) {
      this.listen(this.refs.form,
        'submit',
        function (event) {
          event.preventDefault();

          if (
            !self.refs.button ||
            self.refs.button.disabled ||
            self.isSubmitting
          ) {
            return;
          }

          self.addToCart(false);
        }
      );
    }

    if (this.refs.quickButton) {
      this.listen(this.refs.quickButton,
        'click',
        function () {
          if (
            self.refs.quickButton.disabled ||
            self.isSubmitting
          ) {
            return;
          }

          self.addToCart(true);
        }
      );
    }
  };

  function getInstanceFromOptions(options) {
    var settings = options || {};

    if (
      settings.buyboxId &&
      instances.has(String(settings.buyboxId))
    ) {
      return instances.get(String(settings.buyboxId));
    }

    var selected = null;

    instances.forEach(function (instance) {
      if (
        !selected &&
        instance.root &&
        instance.root.isConnected
      ) {
        selected = instance;
      }
    });

    return selected;
  }

  function collectQuickBenefits(scope) {
    var roots = [];
    var target = scope || document;

    if (
      target.nodeType === 1 &&
      target.matches &&
      target.matches('[data-dlt-quick-benefits]')
    ) {
      roots.push(target);
    }

    if (target.querySelectorAll) {
      roots = roots.concat(
        Array.prototype.slice.call(
          target.querySelectorAll('[data-dlt-quick-benefits]')
        )
      );
    }

    return roots;
  }

  function syncQuickBenefits(scope) {
    var compact = quickBenefitsMedia ? quickBenefitsMedia.matches : false;

    collectQuickBenefits(scope || document).forEach(function (details) {
      var summary = details.querySelector('.dlt-quick-benefits__summary');
      var wasReady = details.classList.contains('is-ready');

      if (compact) {
        if (!wasReady) {
          details.open = false;
        }
        if (summary) summary.tabIndex = 0;
      } else {
        details.open = true;
        if (summary) summary.tabIndex = -1;
      }

      details.classList.add('is-ready');
    });
  }

  function collectRoots(scope) {
    var roots = [];

    if (!scope) return roots;

    if (
      scope.nodeType === 1 &&
      scope.matches &&
      scope.matches(ROOT_SELECTOR)
    ) {
      roots.push(scope);
    }

    if (scope.querySelectorAll) {
      roots = roots.concat(
        Array.prototype.slice.call(
          scope.querySelectorAll(ROOT_SELECTOR)
        )
      );
    }

    return roots;
  }

  function boot(scope) {
    syncQuickBenefits(scope || document);

    collectRoots(scope || document).forEach(function (root) {
      var uid =
        root.getAttribute('data-dlt-buybox-id') || '';

      if (!uid) return;

      if (instances.has(uid)) {
        var existingInstance = instances.get(uid);

        if (
          existingInstance &&
          existingInstance.root === root &&
          existingInstance.root.isConnected
        ) {
          return;
        }

        if (
          existingInstance &&
          (!existingInstance.root ||
            !existingInstance.root.isConnected)
        ) {
          existingInstance.destroy();
          instances.delete(uid);
        } else {
          return;
        }
      }

      var instance = new BuyBox(root);
      instances.set(uid, instance);
      instance.init();
    });
  }

  function destroyIn(scope) {
    if (!scope) return;

    instances.forEach(function (instance, uid) {
      if (
        scope === instance.root ||
        (scope.contains &&
          scope.contains(instance.root))
      ) {
        instance.destroy();
        instances.delete(uid);
      }
    });
  }

  function queueBoot(scope) {
    pendingScopes.push(scope || document);

    if (bootFrame) return;

    bootFrame = window.requestAnimationFrame(function () {
      var scopes = pendingScopes.slice();
      pendingScopes.length = 0;
      bootFrame = 0;

      scopes.forEach(boot);
    });
  }

  window.DLTBuyBox = {
    version: '27.2.0',
    boot: boot,
    destroyIn: destroyIn,
    instances: instances,
    refreshCart: refreshAllCartStates,
    moneyBr: moneyBr
  };

  window.dltSubmitPdpBuyBox = function (options) {
    var instance = getInstanceFromOptions(options);
    if (!instance) return false;

    if (
      !instance.refs.button ||
      instance.refs.button.disabled ||
      instance.isSubmitting
    ) {
      return false;
    }

    return instance.addToCart(
      !!(options && options.checkout)
    );
  };

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      queueBoot(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      destroyIn(event.target);
    }
  );

  document.addEventListener(
    'cart:refresh',
    function () {
      window.clearTimeout(cartRefreshTimer);

      cartRefreshTimer = window.setTimeout(
        function () {
          refreshAllCartStates(false);
        },
        120
      );
    }
  );

  document.addEventListener(
    'dlt:cart:updated',
    function (event) {
      var cartState =
        event &&
        event.detail &&
        event.detail.cart
          ? event.detail.cart
          : null;

      if (cartState) {
        setCartCache(
          cartState,
          cartCache.url || (((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js')
        );
        applyCartStateToInstances(cartState);
      } else {
        refreshAllCartStates(false);
      }
    }
  );

  document.addEventListener(
    'visibilitychange',
    function () {
      instances.forEach(function (instance) {
        if (document.hidden) {
          instance.stopCountdown();
        } else {
          instance.syncCountdownTimer();
        }
      });
    }
  );

  if (quickBenefitsMedia) {
    var handleQuickBenefitsBreakpoint = function () {
      document
        .querySelectorAll('[data-dlt-quick-benefits]')
        .forEach(function (details) {
          var summary = details.querySelector('.dlt-quick-benefits__summary');

          if (quickBenefitsMedia.matches) {
            details.open = false;
            if (summary) summary.tabIndex = 0;
          } else {
            details.open = true;
            if (summary) summary.tabIndex = -1;
          }

          details.classList.add('is-ready');
        });
    };

    if (typeof quickBenefitsMedia.addEventListener === 'function') {
      quickBenefitsMedia.addEventListener('change', handleQuickBenefitsBreakpoint);
    } else if (typeof quickBenefitsMedia.addListener === 'function') {
      quickBenefitsMedia.addListener(handleQuickBenefitsBreakpoint);
    }
  }

  function start() {
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }
})();